module.exports = __webpack_public_path__ + "img/5-4.d1ac8ad2.png";